<template>
  <v-chart ref="chart" :options="options" autoresize />
</template>

<script>
import Vue from 'vue';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/legend';

export default Vue.extend({
  components: {
    'v-chart': ECharts,
  },
  props: {
    deviceData: {
      type: Array,
      default() {
        return [];
      },
    },
    dataToShow: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      graphData: {
        desktop: 0,
        mobile: 0,
        tablet: 0,
        other: 0,
      },
    };
  },
  computed: {
    options() {
      return {
        legend: {
          icon: 'circle',
        },
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            type: 'pie',
            data: [
              {
                name: 'Desktop',
                itemStyle: {
                  color: '#013069',
                },
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                },
                value: this.graphData.desktop,
              },
              {
                name: 'Mobile',
                itemStyle: {
                  color: '#4D92E3',
                },
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                },
                value: this.graphData.mobile,
              },
              {
                name: 'Tablet',
                itemStyle: {
                  color: '#E39E4D',
                },
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                },
                value: this.graphData.tablet,
              },
              {
                name: 'Other',
                itemStyle: {
                  color: '#C6C6C6',
                },
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                },
                value: this.graphData.other,
              },
            ],
          },
        ],
      };
    },
  },
  watch: {
    deviceData: {
      handler(val) {
        if (val) {
          const desktop = val.find(i => i.device === 'DESKTOP');
          const mobile = val.find(i => i.device === 'MOBILE');
          const tablet = val.find(i => i.device === 'TABLET');
          const other = val.find(i => i.device === 'OTHER');
          this.graphData.desktop = desktop ? desktop[this.dataToShow] : 0;
          this.graphData.mobile = mobile ? mobile[this.dataToShow] : 0;
          this.graphData.tablet = tablet ? tablet[this.dataToShow] : 0;
          this.graphData.other = other ? other[this.dataToShow] : 0;
        }
      },
      deep: true,
      immediate: true,
    },
  },
});
</script>

<style scoped></style>
